import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.842 14.029a5.5 5.5 0 0 1 10.266-2.14q.138-.01.277-.01a4.103 4.103 0 1 1 0 8.208h-9.8a3.074 3.074 0 0 1-.743-6.058"
      clipRule="evenodd"
    />
    <path
      fill="#EDB326"
      d="M13.745 3.768a.75.75 0 1 0 1.465-.326l-.265-1.19a.75.75 0 0 0-1.464.325zM18.222 4.967a.75.75 0 0 1-.23-1.035l.655-1.03a.75.75 0 1 1 1.266.806l-.655 1.029a.75.75 0 0 1-1.036.23M9.367 4.965a.75.75 0 0 1 1.036-.23l1.031.656a.75.75 0 1 1-.805 1.265L9.597 6a.75.75 0 0 1-.23-1.035M11.8 7.74a7.37 7.37 0 0 1 4.35 2.66c.987.082 1.918.401 2.717.905A4 4 0 1 0 11.8 7.739M20.613 13.01l.326.207a.75.75 0 1 0 .805-1.265l-1.029-.655a.75.75 0 0 0-1.145.527 5.7 5.7 0 0 1 1.043 1.186M20.31 7.945a.75.75 0 0 1 .569-.895l1.19-.264a.75.75 0 0 1 .326 1.464l-1.19.265a.75.75 0 0 1-.895-.57"
    />
  </>
);

const Weather28Colored = Icon('weather-28-colored', svgContents);

export default Weather28Colored;
